import st from "./index.module.scss";
import { GameType } from "@/domains/games/types";
import { ProviderType } from "@/domains/providers/types";
import { useStore } from "@/hooks/use-store";
import React from "react";

export default function ItemsListSearch<T extends GameType | ProviderType>({
  items,
  Cart,
}: {
  items: T[];
  Cart: ({ item }: { item: T }) => React.JSX.Element;
}) {
  const { modal } = useStore();

  if (items.length === 0) return null;

  return (
    <ul className={st.games_list}>
      {items.map((item, idx) => (
        <li
          onClick={() => modal.closeModal()}
          className={st.games_list__item}
          key={`${item.slug}+${idx}`}
        >
          <Cart item={item} />
        </li>
      ))}
    </ul>
  );
}
